export default {
  contracts: {
    activeContracts: 'Aktywne kontrakty',
    productsAndHours: 'Serwisowane produkty i godziny do wykorzystania',
    supported: 'Serwisowane',
    notSupported: 'Nie serwisowane',
    contact: 'Manager'
  },
  states: {
    OPEN: 'Otware',
    AWAITING_REPLY: 'Oczekuje odpowiedzi',
    CLOSED: 'Zamknięte',
    FEEDBACK_REQUIRED: 'Opinia zwrotna wymagana',
    onlyRequired: 'Pokaż tylko wymagane działania',
    onlyWorkRequests: 'Pokaż tylko zatwierdzenie wniosków o pracę'
  },
  common: {
    New: 'Nowe',
    Open: 'Otware',
    Pending: 'Oczekujące',
    Closed: 'Zamknięte',
    create: 'Utwórz',
    cancel: 'Anuluj',
    goBack: 'Cofnij',
    close: 'Zamknij',
    goToMain: 'Idź do strony głównej'
  },
  property: {
    name: 'Obiekt',
    allProperties: 'Wszystkie Obiekty',
    selectProperty: 'Wybierz obiekt'
  },
  product: {
    name: 'Produkt',
    allProducts: 'Wszystkie produkty',
    selectProduct: 'Wybirze produkt',
    goBack: 'Cofnij',
    noProducts: 'Brak produktu'
  },
  chart: {
    chooseMonth: 'Wybierz miesiąc',
    noData: 'Brak danych za wybrany okres'
  },
  navigation: {
    main: 'STRONA GŁÓWNA',
    interactions: 'ZGŁOSZENIA',
    contracts: 'KONTRAKTY',
    signOut: 'WYLOGUJ SIĘ'
  },
  tickets: {
    createNewTitle: 'Utwórz nowe zgłoszenie',
    title: 'Tytuł',
    noTickets: 'Brak zgłoszeń spełniających kryteria filtrowania',
    search: 'Wyszukaj',
    createNew: 'Utwórz nowe',
    reopenOrDisagree: 'Nie zgadzam się',
    escalation: 'Eskalacja',
    reason: 'Powód',
    reopen: 'Nie zgadzam się',
    escalate: 'Eskaluj',
    opinionTitle: 'Twoja opinia jest dla nas ważna!',
    opinionBody: 'Oceń proszę pracę naszego serwisu',
    time: 'Czas rozwiązania',
    qualification: 'Umiejętności techniczne',
    communication: 'Umiejętności komunikacjyjne',
    sendFeedback: 'Wyślij opinię zwrotną',
    leaveFeedback: 'Pozostaw opinie zwrotną',
    close: 'Zamknij',
    alreadyHasFeedback: 'To zgłoszenie, już posiada opinię zwrotną',
    feedbackHasBeenSent: 'Opinia zwrotna została wysłana',
    ticketHasBeenReopened: 'Zgłoszenie zostało ponownie otwarte',
    ticketHasBeenEscalated: 'Zgłoszenie zostało eskalowane',
    comment: 'Uwagi',
    keyPlaceholder: 'Wpisz wiadomość',
    approve: 'Zatwierdzić',
    reject: 'Odrzucić',
    workRequestOnContractNotification:
      'Szanowny Panie/Pani {{fullName}},\\n\\nObecnie przysługuje Państwu {{hoursInSupportContract}} godzin serwisowych w ramach usług o wartości dodanej ujętych w umowie wsparcia.\\nZgłoszenie nr {{workRequestId}} będzie wymagało {{hoursRequested}} godzin na jego ukończenie.\\n\\nProsimy o zatwierdzenie wykorzystania tych godzin z dostępnej puli na wykonanie powyższego zadania.\\nSerdecznie dziękujemy.\\n\\nZ wyrazami szacunku,\\n{{author}}',
    workRequestChargeableNotification:
      'Szanowny Panie/Pani {{fullName}},\\n\\nInformujemy, że ta praca nie jest uwzględniona w świadczonych usługach ani nie jest objęta gwarancją w ramach umowy wsparcia. Chętnie zaplanujemy i pomożemy w jej realizacji. Szacujemy, że wykonanie zadania ze zgłoszenia numer {{workRequestId}} zajmie {{hoursRequested}} godzin.\\n\\nKoszt realizacji tego zgłoszenia wyniesie {{amount}}.\\nNiniejsza oferta jest ważna przez 7 dni od daty wystawienia.\\nJeśli rzeczywisty czas realizacji przekroczy pierwotną wycenę, zostanie przesłany dodatkowy formularz z prośbą o zatwierdzenie dodatkowych godzin. Jeśli szacowany czas będzie krótszy niż pierwotna wycena, zostanie przesłana nowa propozycja cenowa, a pierwotna zostanie anulowana.\\n\\n Prosimy o zatwierdzenie dodatkowych prac oraz opłat.\\n\\nZ wyrazami szacunku,\\n{{author}}',
    workRequestCommentRequired: 'Proszę podać powód odrzucenia prośby o pracę.'
  },
  severity: {
    name: 'Poziom zgłoszenia',
    0: 'Normalny',
    1: 'Wysoki',
    2: 'Krytyczny'
  },
  forms: {
    password: 'Hasło',
    confirmPassword: 'Potwierdź hasło',
    passwordsDoNotMatch: 'Hasło się nie zgadza',
    updatePassword: 'Zmień hasło',
    askRestore: 'Zapytaj o zmianę hasła',
    remember: 'Zapamiętaj mnie',
    restorePassword: 'Odzyskaj hasło',
    signIn: 'Zaloguj'
  },
  transactions: {
    date: 'Data',
    type: 'Typ',
    comment: 'Uwagi',
    status: 'Status',
    subject: 'Zlecenia dodatkowej pracy',
    name: 'Lista transakcji',
    hours: 'Godziny',
    viewTransactions: 'Zobacz transakcje',
    types: {
      WORK_REQUEST: 'Zlecenie dodatkowej pracy',
      CONTRACT_ACTIVATION: 'Aktywacja kontraktu',
      CONTRACT_EXPIRATION: 'Kontrakt wygasa',
      MANUAL_ADJUST_ADD: 'Manualna zmina - dodaj',
      MANUAL_ADJUST_DEDUCT: 'Manualna zmiana - odejmij',
      TRANSFER_PROPERTY: 'Przenieś pomiędzy obiektami',
      TRANSFER_PRODUCT: 'Przenieś produkt'
    }
  },
  transactionDetail: {
    name: 'Szczegóły transakcji',
    num: 'Numer',
    insertTime: 'Data utworzenia',
    requestorName: 'Zgłaszający',
    subject: 'Temat',
    status: 'Status',
    acceptTime: 'Data akceptacji',
    cancelTime: 'Data anulacji',
    hours: 'Godziny',
    hourType: 'Typ godzin',
    workText: 'Opis dodatkowej pracy',
    plannedDate: 'Data planowana'
  },
  statuses: {
    Approved: 'Zaakceptowane',
    Pending: 'Oczekujące',
    Cancelled: 'Anulowane'
  },
  hoursTypes: {
    'Included in contract': 'Wliczone w kontrakt',
    'Installation hours': 'Godziny instalacyjne',
    'Preventative visit': 'Wizyta prewencyjna',
    Chargeable: 'Płatne'
  },
  errors: {
    unknown: 'Błąd nieznany',
    1000: 'Błąd zapytania',
    1001: 'Błąd zapytania',
    1: 'Nieprawidłowy użytkownik lub hasło',
    2: 'Sesja wygasła',
    3: 'Nieznany obiekt',
    4: 'Nieznany produkt',
    7: 'Nieznana interakcja',
    8: 'Interakcja zakończona',
    11: 'Naruszenie dostępu',
    12: 'Nieznane zadanie do wykonania'
  }
}
